/* ==========================================================================
   LINENFRIDAY REDESIGN — animacije (Ozbej)
   Scroll-reveal z IntersectionObserver (brez zunanjih knjiznic).
   Animacije se ponovijo ob vsakem scrollu (kot v potrjenem predogledu).
   Spostuje prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';
  document.documentElement.classList.add('lf-js');

  /* Opomba: reduce-motion NE prekine celotnega skripta (sicer bi mnenja/header
     ne delovali). Vsaka funkcija sama spostuje reduce-motion — reveal prek CSS,
     stevec/rotacija mnenj prek spremenljivke REDUCED. */

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Registri reveal-sprozilcev + pomocnik: ob navigaciji iz menija TAKOJ
     sestavi celo stran (vse reveal-e na koncno stanje in unici njihove
     sprozilce), da drsenje ni prekinjeno s "pop-in" animacijami sekcij. */
  var lfRevealTriggers = [];
  function lfRevealAllNow() {
    if (window.gsap) {
      try { gsap.set('.lf-reveal', { opacity: 1, y: 0, clearProps: 'transform' }); } catch (e) {}
    }
    for (var i = 0; i < lfRevealTriggers.length; i++) {
      try { if (lfRevealTriggers[i]) lfRevealTriggers[i].kill(); } catch (e2) {}
    }
    lfRevealTriggers.length = 0;
  }

  /* Odmik zaradi sticky headerja (da sekcija ne pristane skrita pod njim). */
  function lfHeaderOffset() {
    var h = document.querySelector('.shopify-section__header, .section-header, header');
    var hh = h ? h.getBoundingClientRect().height : 0;
    return hh + 6;
  }
  /* Nadzorovano drsenje (rAF, easeInOutCubic) namesto native scrollIntoView:
     enakomerno gibanje + med potjo IZKLOPIMO blur headerja (razred lf-navigating),
     ker se sicer prerisuje vsak frame in ravno na koncu "drgne"/preskakuje. */
  function lfScrollToEl(target) {
    var startY = window.pageYOffset || document.documentElement.scrollTop;
    var destY = Math.max(0, target.getBoundingClientRect().top + startY - lfHeaderOffset());
    var dist = destY - startY;
    if (REDUCED || Math.abs(dist) < 4) { window.scrollTo(0, destY); return; }
    var dur = Math.min(900, Math.max(480, Math.abs(dist) * 0.42));
    var t0 = null;
    var root = document.documentElement;
    root.classList.add('lf-navigating');
    function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      window.scrollTo(0, startY + dist * ease(p));
      if (p < 1) { requestAnimationFrame(step); }
      else { root.classList.remove('lf-navigating'); }
    }
    requestAnimationFrame(step);
  }

  /* oznaci elemente za reveal (doda .lf-reveal razred; animira jih GSAP).
     Opomba: NE animiramo vsake kartice/vrata posebej — sekcije imajo svoj
     [data-lf-reveal] in se pojavijo kot celota. Manj sprozilcev = gladko
     (posebej ob skoku na oddaljeno sekcijo prek nav sidra). */
  var SELECTORS = [
    '[data-lf-reveal]',
    '.section__header',
    '.image-with-text__wrapper',
    '.rich-text__wrapper',
    '.newsletter__wrapper',
    '.feedback-form'
  ].join(',');
  function markTargets(root) {
    var els = (root || document).querySelectorAll(SELECTORS);
    for (var i = 0; i < els.length; i++) { els[i].classList.add('lf-reveal'); }
  }
  markTargets(document);

  /* EN sam rAF-batchan scroll dispatcher (header stanje, mnenja ...) */
  var lfScrollTasks = [];
  var lfScrollScheduled = false;
  function lfRunScroll() {
    lfScrollScheduled = false;
    for (var i = 0; i < lfScrollTasks.length; i++) { try { lfScrollTasks[i](); } catch (e) {} }
  }
  function lfScheduleScroll() {
    if (lfScrollScheduled) return;
    lfScrollScheduled = true;
    (window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); })(lfRunScroll);
  }
  window.addEventListener('scroll', lfScheduleScroll, { passive: true });
  window.addEventListener('resize', lfScheduleScroll, { passive: true });
  function addScrollTask(fn) { lfScrollTasks.push(fn); try { fn(); } catch (e) {} }

  var html = document.documentElement;
  function onScroll() { html.classList.toggle('lf-scrolled', window.scrollY > 40); }
  addScrollTask(onScroll);

  /* ==========================================================================
     GSAP ANIMACIJE — preneseno iz predogleda (clean easing, ponavljajoc reveal,
     gladek scrub parallax). Ce GSAP ni na voljo / reduce-motion / viewport 0 →
     vse takoj vidno (nikoli obticano skrito).
     ========================================================================== */
  function showAllReveals() {
    var e = document.querySelectorAll('.lf-reveal');
    for (var i = 0; i < e.length; i++) { e[i].style.opacity = 1; e[i].style.transform = 'none'; }
  }
  function initGsap() {
    if (!window.gsap || REDUCED) { showAllReveals(); return; }
    gsap.registerPlugin(ScrollTrigger);

    /* hero intro (ob nalozitvi, kot predogled) */
    gsap.from('.lf-hero__eyebrow, .lf-hero__title, .lf-hero__subtitle, .lf-hero__actions', {
      y: 30, opacity: 0, duration: 1, ease: 'power3.out', stagger: 0.14, delay: 0.25
    });

    /* Scroll-animacije potrebujejo realno visino viewporta. Ce je 0 (predogled
       brez dimenzij / headless), pusti vse vidno. */
    if (!window.innerHeight || window.innerHeight < 1) { showAllReveals(); return; }
    ScrollTrigger.config({ ignoreMobileResize: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
    }

    /* hero parallax — gladek scrub (slika zoom, vsebina dvig+zbledi) */
    var hImg = document.querySelector('.lf-hero__img') || document.querySelector('.lf-hero__placeholder');
    if (hImg) {
      gsap.to(hImg, { yPercent: 10, scale: 1.05, ease: 'none',
        scrollTrigger: { trigger: '.lf-hero', start: 'top top', end: 'bottom top', scrub: 0.5 } });
    }
    if (document.querySelector('.lf-hero__content')) {
      gsap.to('.lf-hero__content', { yPercent: -14, opacity: 0.1, ease: 'none',
        scrollTrigger: { trigger: '.lf-hero', start: 'top top', end: 'bottom top', scrub: 0.5 } });
    }

    /* generic reveal — ENKRATNO (play ob prvem vstopu, potem OSTANE viden).
       once:true unici sprozilec po predvajanju → ob scrollu navzgor se NIC ne
       obrne/ponovi (prej je 'reverse' povzrocal kaskado tweenov = laggy). */
    gsap.utils.toArray('.lf-reveal').forEach(function (elm) {
      if (elm.closest('.lf-hero')) return;
      var tw = gsap.fromTo(elm, { opacity: 0, y: 34 }, {
        opacity: 1, y: 0, duration: 1.15, ease: 'power3.out',
        scrollTrigger: { trigger: elm, start: 'top 88%', once: true }
      });
      if (tw && tw.scrollTrigger) { lfRevealTriggers.push(tw.scrollTrigger); }
    });

    /* story parallax */
    if (document.querySelector('.lf-story__photo')) {
      gsap.to('.lf-story__photo', { yPercent: -8, ease: 'none',
        scrollTrigger: { trigger: '.lf-story', start: 'top bottom', end: 'bottom top', scrub: true } });
    }
  }
  var lfGsapDone = false;
  function initGsapOnce() { if (lfGsapDone) return; lfGsapDone = true; initGsap(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGsapOnce);
  } else {
    initGsapOnce();
  }
  /* varovalka: ce GSAP ni bil na voljo ob initu (pocasen CDN), po load pokazi vse */
  window.addEventListener('load', function () { if (!window.gsap) showAllReveals(); });

  /* ---- hero-page: header prekrije hero (prosojen) samo ce je hero na strani ----
     Izmerimo visino headerja in jo damo v --lf-header-h, da hero potegnemo
     tocno pod header (odzivno, brez fiksnih vrednosti). */
  function markHeroPage() {
    var hero = document.querySelector('.lf-hero');
    var header = document.querySelector('.shopify-section__header');
    if (hero && header) {
      html.classList.add('lf-hero-page');
      html.style.setProperty('--lf-header-h', header.getBoundingClientRect().height + 'px');
    } else {
      html.classList.remove('lf-hero-page');
    }
  }

  function scheduleHeaderMeasure() {
    markHeroPage();
    setTimeout(markHeroPage, 250);   // po nalozitvi pisav se visina lahko spremeni
  }

  scheduleHeaderMeasure();
  window.addEventListener('resize', markHeroPage);
  window.addEventListener('load', markHeroPage);

  /* Shopify theme editor: ponovno oznaci nove elemente ob nalaganju sekcij.
     GSAP zanje ne ustvari novega trigger-ja, zato jih v editorju takoj pokazi
     (da ne obticijo skriti med urejanjem). */
  document.addEventListener('shopify:section:load', function (e) {
    markTargets(e.target);
    var nr = e.target.querySelectorAll('.lf-reveal');
    for (var i = 0; i < nr.length; i++) { nr[i].style.opacity = 1; nr[i].style.transform = 'none'; }
    if (window.ScrollTrigger) { try { ScrollTrigger.refresh(); } catch (x) {} }
    scheduleHeaderMeasure();
    initReviews();
  });

  /* ---- MNENJA: prava Judge.me mnenja → demo-slog mreza (kot predogled) ----
     Judge.me featured carousel je skrit vir; preberemo citate + avtorje +
     skupno stevilo in izrisemo v .lf-reviews__grid. Fallback: prikazemo
     carousel, ce Judge.me ne naloDZi mnenj. */
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function buildReviewCard() {
    var card = document.createElement('div');
    card.className = 'lf-review lf-in';
    card.innerHTML =
      '<div class="lf-review__mark" aria-hidden="true">”</div>' +
      '<div class="lf-review__q"></div>' +
      '<div class="lf-review__who"></div>';
    return card;
  }

  function setCard(card, r) {
    card.querySelector('.lf-review__q').textContent = r.quote;
    card.querySelector('.lf-review__who').textContent = r.who;
  }

  function extractReviews(source) {
    var items = source.querySelectorAll('.jdgm-carousel-item');
    var out = [];
    var seen = {};
    for (var i = 0; i < items.length; i++) {
      var contentEl = items[i].querySelector('.jdgm-carousel-item__review-content, .jdgm-carousel-item__review-body');
      var nameEl = items[i].querySelector('.jdgm-carousel-item__reviewer-name');
      if (!contentEl) continue;
      var raw = contentEl.innerText || contentEl.textContent || '';
      var parts = raw.split(/\n{2,}/).map(function (p) { return p.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
      var quote = parts.length >= 2 ? parts.slice(1).join(' ') : (parts[0] || '');
      if (quote.length < 10 && parts[0]) { quote = parts[0]; }
      if (quote.length < 18) continue;
      if (quote.length > 240) quote = quote.slice(0, 237).replace(/\s+\S*$/, '') + '…';
      if (seen[quote]) continue;
      seen[quote] = 1;
      var who = nameEl ? (nameEl.textContent || '').replace(/\s+/g, ' ').trim() : '';
      out.push({ quote: quote, who: who || '—' });
    }
    return out;
  }

  function getTotal(source) {
    var numEl = source.querySelector('.jdgm-carousel-number-of-reviews');
    if (!numEl) return 0;
    var m = (numEl.textContent || '').replace(/\s/g, ' ').match(/(\d[\d.,]*)/);
    return m ? parseInt(m[1].replace(/[.,]/g, ''), 10) : 0;
  }

  function animateCount(el, total) {
    if (!total) return;
    if (REDUCED) { el.textContent = total + '+'; return; }
    /* setInterval (ne requestAnimationFrame) — deluje tudi ce je zavihek nevideni */
    var steps = 42, i = 0;
    var timer = setInterval(function () {
      i++;
      var p = i / steps;
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(eased * total) + '+';
      if (i >= steps) { clearInterval(timer); el.textContent = total + '+'; }
    }, 38);
  }

  function setupReviews(section, reviews, source) {
    var grid = section.querySelector('[data-lf-review-grid]');
    var countEl = section.querySelector('[data-lf-review-count]');
    var perView = Math.min(3, reviews.length);
    grid.innerHTML = '';
    var cards = [];
    for (var i = 0; i < perView; i++) {
      var c = buildReviewCard();
      setCard(c, reviews[i]);
      grid.appendChild(c);
      cards.push(c);
    }
    section.classList.add('lf-reviews--ready');

    /* stevilo preberemo SELE ko pride sekcija v pogled (Judge.me ga izrise
       lahko z zamikom), nato ga animiramo 0 → total. */
    /* Stevec: scroll + getBoundingClientRect (zanesljivo v vseh brskalnikih;
       IntersectionObserver je v nekaterih okoljih nezanesljiv). */
    var counted = false;
    var countTarget = section.querySelector('.lf-reviews__top') || countEl || section;
    function maybeCount() {
      if (counted) return;
      var r = countTarget.getBoundingClientRect();
      var inView = r.top < (window.innerHeight * 0.9) && r.bottom > 0;
      if (!inView) return;
      var total = getTotal(source);
      if (!total) return;
      counted = true;
      animateCount(countEl, total);
    }
    addScrollTask(maybeCount);   /* skupni rAF-batch (pravi brskalniki) */
    var pc = 0;                  /* + polling backup (zanesljivo tudi kjer je rAF upocasnjen) */
    var pi = setInterval(function () { maybeCount(); if (counted || ++pc > 160) clearInterval(pi); }, 400);

    if (!REDUCED && reviews.length > perView) {
      var offset = 0;
      var timer = null;
      function tick() {
        offset = (offset + perView) % reviews.length;
        grid.classList.add('lf-reviews__grid--fading');
        setTimeout(function () {
          for (var j = 0; j < perView; j++) { setCard(cards[j], reviews[(offset + j) % reviews.length]); }
          grid.classList.remove('lf-reviews__grid--fading');
        }, 450);
      }
      function start() { if (!timer) timer = setInterval(tick, 5200); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      start();
      grid.addEventListener('mouseenter', stop);
      grid.addEventListener('mouseleave', start);
    }
  }

  function populateReviews(section) {
    var grid = section.querySelector('[data-lf-review-grid]');
    var source = section.querySelector('[data-lf-review-source]');
    if (!grid || !source) return false;
    if (!source.querySelectorAll('.jdgm-carousel-item').length) return false;
    var reviews = extractReviews(source);
    if (!reviews.length) return false;
    setupReviews(section, reviews, source);
    return true;
  }
  function initReviews() {
    var sections = document.querySelectorAll('.lf-reviews');
    for (var s = 0; s < sections.length; s++) {
      (function (section) {
        if (section.dataset.lfReviewsDone) return;
        var tries = 0;
        var iv = setInterval(function () {
          tries++;
          if (populateReviews(section)) {
            section.dataset.lfReviewsDone = '1';
            clearInterval(iv);
          } else if (tries > 20) {              /* ~10s: fallback na carousel */
            clearInterval(iv);
            section.classList.add('lf-reviews--fallback');
          }
        }, 500);
      })(sections[s]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviews);
  } else {
    initReviews();
  }

  /* ---------------------------------------------------------------------------
     LANDING KOLEKCIJE (Ozbej): pokazi N izdelkov, "View entire collection"
     odkrije ostale. Deluje file-only, brez novih strani.
     --------------------------------------------------------------------------- */
  function initCollectionLanding() {
    var grid = document.querySelector('[data-lf-landing="true"]');
    var box = document.querySelector('[data-lf-viewall]');
    if (!grid) return;
    var count = parseInt(grid.getAttribute('data-lf-landing-count'), 10) || 4;
    var items = [].slice.call(grid.querySelectorAll('.product-item'));
    if (items.length <= count) { if (box) box.hidden = true; return; }
    for (var i = count; i < items.length; i++) { items[i].classList.add('lf-landing-hidden'); }
    if (box) {
      box.hidden = false;
      var btn = box.querySelector('[data-lf-viewall-btn]');
      if (btn) {
        btn.addEventListener('click', function () {
          for (var j = 0; j < items.length; j++) {
            items[j].classList.remove('lf-landing-hidden');
            items[j].classList.add('lf-in'); /* ce je reveal, pokazi takoj */
          }
          box.hidden = true;
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionLanding);
  } else {
    initCollectionLanding();
  }

  /* ---------------------------------------------------------------------------
     DARILNI BON (Ozbej): klik na znesek menja znesek na kartici (kot predogled).
     --------------------------------------------------------------------------- */
  function initGiftCard() {
    var sections = document.querySelectorAll('[data-section-type="lf-giftcard"]');
    for (var s = 0; s < sections.length; s++) {
      (function (sec) {
        var amountEl = sec.querySelector('[data-gc-amount]');
        var btns = sec.querySelectorAll('.lf-gift__amt');
        for (var i = 0; i < btns.length; i++) {
          btns[i].addEventListener('click', function () {
            for (var j = 0; j < btns.length; j++) { btns[j].classList.remove('is-active'); }
            this.classList.add('is-active');
            if (amountEl) {
              amountEl.textContent = this.getAttribute('data-val');
              amountEl.style.transform = 'scale(1.08)';
              setTimeout(function () { amountEl.style.transform = ''; }, 180);
            }
          });
        }
      })(sections[s]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftCard);
  } else {
    initGiftCard();
  }

  /* ---------------------------------------------------------------------------
     NAV → DOMACE SEKCIJE (Ozbej): klik na kategorijo v headerju pelje na domaco
     sekcijo (predogled), NE na cel seznam. "View entire collection" v sekciji
     pa vodi na cel seznam. Preusmeritev prek preslikave (menu ostane v adminu).
     --------------------------------------------------------------------------- */
  function initNavToHome() {
    /* Preslikavo lokalizirana-rocica → sidro pripravi strezniski del (header.liquid:
       window.LF_NAV_MAP), zato deluje ENAKO v vseh 4 jezikih (v drugih jezikih so
       rocice v URL prevedene). Tu samo prevezemo href na lokalizirano domaco sidro. */
    var map = window.LF_NAV_MAP || {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) === '/') { root = root.slice(0, -1); }
    /* DESKTOP inline nav + VSE mobilne menu povezave. Ujamemo prvo /collections/<h>
       ali /pages/<h> rocico; le ce je v preslikavi (glavne kategorije) → prevezemo.
       Sub-kolekcije in social/email povezave se NE ujemajo → ostanejo nespremenjene. */
    var links = document.querySelectorAll('.nav-bar--lf-inrow .nav-bar__link[data-type="menuitem"], .header__mobile-nav a[href], .mobile-menu a[href], .drawer-menu a[href]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      var m = href.match(/\/(?:collections|pages)\/([^\/?#]+)/);
      if (!m) { continue; }
      var anchor = map[m[1]];
      if (anchor) { links[i].setAttribute('href', root + '/#' + anchor); }
    }
  }

  /* gladko drsenje na sidro znotraj domace strani (brez skoka pod sticky header).
     Na mobilnem: najprej zapri hamburger drawer, sele nato zdrsni. */
  function initAnchorScroll() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="#lf-cat-"]') : null;
      if (!a) return;
      var hash = a.getAttribute('href').split('#')[1];
      if (!hash) return;
      /* Ce sidro OBSTAJA na tej strani → gladko zdrsni (velja za vse jezike / korene
         /de,/sl,/it in ne glede na koncno posevnico). Sicer pusti brskalniku, da
         odpre domaco stran s #sidrom (cross-page skok). */
      var target = document.getElementById(hash);
      if (target) {
        e.preventDefault();
        /* sestavi celo stran, da drsenje na sekcijo ni prekinjeno s pop-in animacijami */
        lfRevealAllNow();
        var mmOpen = document.querySelector('.mobile-menu[aria-hidden="false"]');
        if (mmOpen) {
          var t = document.querySelector('[data-action="toggle-menu"]');
          if (t) t.click();
          setTimeout(function () { lfScrollToEl(target); }, 360);
        } else {
          lfScrollToEl(target);
        }
        history.replaceState(null, '', '#' + hash);
      }
    });
  }

  /* mobilni meni kot drawer: klik na temni scrim (izven panela) zapre — kot cart */
  function initMobileMenuScrimClose() {
    document.addEventListener('click', function (e) {
      var mm = document.querySelector('.mobile-menu[aria-hidden="false"]');
      if (!mm || !mm.contains(e.target)) return;
      var inner = mm.querySelector('.mobile-menu__inner');
      if (inner && inner.contains(e.target)) return; /* klik znotraj panela → pusti */
      var t = document.querySelector('[data-action="toggle-menu"]');
      if (t) t.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initNavToHome(); initAnchorScroll(); initMobileMenuScrimClose(); });
  } else {
    initNavToHome();
    initAnchorScroll();
    initMobileMenuScrimClose();
  }

  /* ---------------------------------------------------------------------------
     QUICK VIEW na DOMACIH sekcijah (Ozbej): Warehouse-ov handler je vezan na
     collection sekcijo in ne pokriva domacih kartic, zato modal ostane prazen.
     Tu sami fetchamo {product}?view=quick-view, vstavimo v modal in sprozimo
     'shopify:section:load', da Warehouse init-a produkt (variante + nakup delujejo).
     Scope: samo znotraj .lf-colprev (collection strani ostanejo na native handlerju).
     --------------------------------------------------------------------------- */
  function initHomeQuickView() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.lf-colprev [data-secondary-action="open-quick-view"]') : null;
      if (!btn) return;
      var modal = document.getElementById(btn.getAttribute('aria-controls'));
      var url = btn.getAttribute('data-product-url');
      if (!modal || !url) return;
      var inner = modal.querySelector('.modal__inner');
      if (inner && inner.getAttribute('data-lf-loaded') === url) return; /* ze nalozeno */
      modal.classList.add('is-loading');
      fetch(url + '?view=quick-view', { credentials: 'same-origin', method: 'GET' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (!inner) return;
          inner.innerHTML = html;
          inner.setAttribute('data-lf-loaded', url);
          modal.classList.remove('is-loading');
          /* Warehouse init injected product section → variante + add-to-cart delujejo */
          try { inner.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true })); } catch (err) {}
        })
        .catch(function () { modal.classList.remove('is-loading'); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeQuickView);
  } else {
    initHomeQuickView();
  }
})();
